export function splitContactFio(fullName) {
    const parts = String(fullName || '')
        .trim()
        .split(/\s+/)
        .filter(Boolean);
    return {
        lastName: parts[0] || '',
        firstName: parts[1] || '',
        patronymic: parts.slice(2).join(' ')
    };
}

export function joinContactFio(lastName, firstName, patronymic) {
    return [lastName, firstName, patronymic]
        .filter((x) => x && String(x).trim())
        .join(' ');
}

/**
 * Имя контактного лица для API.
 * В режиме ПВЗ-СДЭК UI редактирует фамилию/имя/отчество отдельно;
 * иначе — одно поле ContactPersonName (при копировании FIO-части могут остаться устаревшими).
 */
export function resolveContactPersonName(contactPersonName, lastName, firstName, patronymic, useSplitFio) {
    if (useSplitFio) {
        return joinContactFio(lastName, firstName, patronymic) || contactPersonName || null;
    }
    return contactPersonName || null;
}



// WEBPACK FOOTER //
// ./App/pages/parcels/form_v3/functions/contactFio.js